import { AddMagnetoDevice } from './add-magneto-report-device.model';

export class AddMagnetoNotification {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            if (json.FailedDevices) json.FailedDevices.map(d => new AddMagnetoDevice(d));
        }
    }

    FailedDevices: AddMagnetoDevice[];
    GatewayUId: string;
    TypeCode: number;
    WasSuccess = false;

    ControllerId: number;
    WasResultOfUserRequest: boolean;
    MessageIdIfResultOfUserRequest: string;
    ErrorCode: string;
    Body: string;
    UId:string;
}
